import {
  FETCH_CORE_ASSORTMENT_COUNT,
  FETCH_CORE_ASSORTMENT_COUNT_FULFILLED,
  FETCH_CORE_ASSORTMENT_COUNT_REJECTED,
} from './actionTypes';
import {
  CoreAssortmentResponseType,
  FetchCoreAssortmentCountAction,
  FetchCoreAssortmentCountFulfilledAction,
  FetchCoreAssortmentCountRejectedAction,
} from './types';

const fetchCoreAssortmentCount = (): FetchCoreAssortmentCountAction => ({
  type: FETCH_CORE_ASSORTMENT_COUNT,
});

const fetchCoreAssortmentCountFulfilled = (response: CoreAssortmentResponseType):
    FetchCoreAssortmentCountFulfilledAction => ({
  type: FETCH_CORE_ASSORTMENT_COUNT_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchCoreAssortmentCountRejected = (error: ErrorType): FetchCoreAssortmentCountRejectedAction => ({
  type: FETCH_CORE_ASSORTMENT_COUNT_REJECTED,
  payload: {
    error,
  },
});

export {
  fetchCoreAssortmentCount,
  fetchCoreAssortmentCountFulfilled,
  fetchCoreAssortmentCountRejected,
};
